import { Component, input } from '@angular/core';
import { faQrcode } from '@fortawesome/free-solid-svg-icons';
import { MainCouranteElement } from '../../main-courante-element.interface';
import { Pointage } from 'src/app/entities/creneaux/pointage.model';
import { IVacation } from 'src/app/entities/vacation/vacation.interface';
import { ICreneauInter } from 'src/app/entities/creneaux/creneau-inter.interface';

@Component({
  selector: 'in2-item-card-pointeau',
  templateUrl: './pointeau.component.html',
  styleUrls: ['./pointeau.component.scss'],
  standalone: false,
})
export class MainCourantePointeauComponent implements MainCouranteElement {
  readonly declaration = input.required<Pointage>();
  readonly vacation = input.required<IVacation>();
  readonly creneau = input.required<ICreneauInter>();

  public faQrcode = faQrcode;
}
